import { FormFieldSeparator } from "@/components/site-builder/modules/CustomFormModule/constants";
import { type FormBuilderFormField } from "@/types/form-builder";

export function generateFieldName(field: FormBuilderFormField) {
  return `${field.id}${FormFieldSeparator}${field.code}`;
}
